<template>
  <div>
    <v-sheet class="body-1 mx-3" v-if="history.length === 0">({{ $tt('caster.noHistoryData') }})</v-sheet>
    <div v-else>
      <e-chart :options="cnrOptions" autoresize style="width: 100%; height: 260px" />
      <e-chart :options="satelliteOptions" autoresize style="width: 100%; height: 260px" />
      <e-chart :options="rateOptions" autoresize style="width: 100%; height: 260px" />
      <e-chart :options="epochOptions" autoresize style="width: 100%; height: 260px" />
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/grid'

import moment from 'moment-timezone'
import i18n from '@/lib/i18n'

const GNSS_ORDER = ['GPS', 'GLONASS', 'GALILEO', 'BEIDOU', 'QZSS', 'SBAS', 'IRNSS']

/**
 * 品質グラフ: 1分集計履歴 (CasterStatsSnapshot[]) から C/N0・衛星数・転送量・エポック間隔を描画
 */
export default {
  name: 'CasterQualityCharts',
  components: {
    'e-chart': ECharts,
  },
  props: {
    history: { type: Array, default: () => [] },
    snapshot: { type: Object, default: null },
  },
  computed: {
    timeLabels() {
      return this.history.map(item => moment(item.collectedAt).format('HH:mm'))
    },
    gnssSystems() {
      const seen = new Set()
      this.history.forEach(item => {
        Object.keys(item.gnss || {}).forEach(system => seen.add(system))
      })
      return GNSS_ORDER.filter(system => seen.has(system))
    },
    cnrOptions() {
      const series = this.gnssSystems.map(system => ({
        name: system,
        type: 'line',
        showSymbol: false,
        data: this.history.map(item => {
          const stat = (item.gnss || {})[system]
          return stat && stat.meanCnr !== null && stat.meanCnr !== undefined ? Number(stat.meanCnr.toFixed(1)) : null
        }),
      }))
      return this.baseOptions(i18n.tt('caster.cnrChart'), series, { min: 20 })
    },
    satelliteOptions() {
      const series = this.gnssSystems.map(system => ({
        name: system,
        type: 'line',
        showSymbol: false,
        data: this.history.map(item => {
          const stat = (item.gnss || {})[system]
          return stat ? stat.satelliteCount : null
        }),
      }))
      return this.baseOptions(i18n.tt('caster.satsChart'), series, {})
    },
    rateOptions() {
      const series = [
        {
          name: 'bytes/s',
          type: 'line',
          showSymbol: false,
          data: this.history.map(item => Math.round(item.bytesInPerSecond)),
        },
      ]
      return this.baseOptions(i18n.tt('caster.rateChart'), series, {})
    },
    epochOptions() {
      const series = [
        {
          name: 'ms',
          type: 'line',
          showSymbol: false,
          data: this.history.map(item =>
            item.epochIntervalMs !== null && item.epochIntervalMs !== undefined
              ? Math.round(item.epochIntervalMs)
              : null
          ),
        },
      ]
      return this.baseOptions(i18n.tt('caster.epochChart'), series, {})
    },
  },
  methods: {
    baseOptions(title, series, { min = null } = {}) {
      return {
        title: { text: title, textStyle: { fontSize: 13 } },
        tooltip: { trigger: 'axis' },
        legend: series.length > 1 ? { data: series.map(item => item.name), top: 24 } : undefined,
        grid: { left: 50, right: 20, top: 56, bottom: 30 },
        xAxis: { type: 'category', data: this.timeLabels },
        yAxis: { type: 'value', min: min === null ? undefined : min },
        series,
      }
    },
  },
}
</script>
